import { subscriptionValidator } from '@/utils/subscriptionValidator';

// Route guard to check subscription status
export function checkSubscription(to, from, next) {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    
    // Allow admin users to bypass subscription check
    if (user.role_name === 'Admin' || user.role === 'admin' || 
        (user.role_details && user.role_details.name === 'admin')) {
      console.log('Admin user bypassing subscription check');
      next();
      return;
    }
    
    // For routes that don't require subscription, allow access
    if (!to.matched.some(record => record.meta.requiresSubscription)) {
      next();
      return;
    }
    
    // Use centralized subscription validation
    const validationResult = subscriptionValidator.isSubscriptionActive(user.subscription_end_date);
    subscriptionValidator.logSubscriptionCheck(user, validationResult);
    
    if (!validationResult.isActive) {
      console.warn('User subscription issue:', {
        reason: validationResult.reason,
        subscription_end_date: user.subscription_end_date,
        user_email: user.email
      });
      
      // Redirect to pricing page
      next({
        path: '/pricing',
        query: { redirect: to.fullPath, reason: validationResult.reason }
      });
      return;
    }
    
    // Subscription is active, allow access
    console.log('User has active subscription, allowing access');
    next();
    
  } catch (error) {
    console.error('Error checking subscription status:', error);
    // On error, redirect to pricing for safety
    next({
      path: '/pricing',
      query: { redirect: to.fullPath, reason: 'subscription_check_error' }
    });
  }
}